export default {"src":"/_next/static/media/image4.d6232cfe.svg","height":258,"width":343,"blurWidth":0,"blurHeight":0};